<template>
  <v-autocomplete
    :value="value"
    :items="items"
    item-text="name"
    item-value="id"
    :loading="loading"
    :disabled="loading || disabled"
    v-on="$listeners"
    label="Planillo"
    name="planillo"
    validation="required"
  ></v-autocomplete>
</template>

<script>
import api from '@/modules/milenium/api';

export default {
  props: {
    publicationId: {
      type: Number,
    },
    value: {
      type: Number,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      items: [],
      loading: false,
    };
  },
  watch: {
    publicationId: {
      async handler(id) {
        this.items = [];
        if (!id) {
          return;
        }
        this.loading = true;
        try {
          this.items = await api.getPublicationPlanillos(id);
        } catch (error) {
          console.error('Error loading milenium publication planillos', error);
        } finally {
          this.loading = false;
        }
      },
      immediate: true,
    },
  },
};
</script>
